import { useEffect, useState } from "react";
import { toast } from "sonner";

const BANNERS = [
  { file: "160x600.jpg", label: "Banner vertical", w: 160, h: 600 },
  { file: "250x250.jpg", label: "Banner quadrado", w: 250, h: 250 },
  { file: "300x250.jpg", label: "Banner retangular", w: 300, h: 250 },
  { file: "336x280.jpg", label: "Banner retangular grande", w: 336, h: 280 },
  { file: "468x60.jpg", label: "Banner horizontal", w: 468, h: 60 },
  { file: "728x90.jpg", label: "Banner horizontal grande", w: 728, h: 90 },
];

function BannerCard({ banner }) {
  const url = `${window.location.origin}/banners/${banner.file}`;
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    fetch(url, { method: "HEAD" })
      .then((r) => {
        const type = r.headers.get("content-type") || "";
        setStatus(r.ok && type.includes("image") ? "ok" : "error");
      })
      .catch(() => setStatus("error"));
  }, [url]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("URL copiada para a área de transferência.");
    } catch {
      toast.error("Não foi possível copiar. Selecione e copie manualmente.");
    }
  };

  return (
    <div
      className="rounded-xl border border-dourado/25 bg-carddark p-4"
      data-testid={`banner-card-${banner.file}`}
    >
      <div className="flex h-36 items-center justify-center overflow-hidden rounded-lg bg-obsidian/60 p-2">
        <img
          src={url}
          alt={`${banner.label} ${banner.w}x${banner.h}`}
          className="max-h-full max-w-full object-contain"
          loading="lazy"
        />
      </div>
      <div className="mt-3 flex items-center justify-between gap-2">
        <div>
          <p className="text-sm font-semibold text-creme">{banner.file}</p>
          <p className="text-xs text-creme/55">
            {banner.label} · {banner.w}×{banner.h}px
          </p>
        </div>
        <span
          data-testid={`banner-status-${banner.file}`}
          className={`flex items-center gap-1.5 text-[0.65rem] font-semibold uppercase tracking-wider ${
            status === "ok" ? "text-emerald-400" : status === "error" ? "text-red-400" : "text-creme/50"
          }`}
        >
          <span
            className={`h-2 w-2 rounded-full ${
              status === "ok" ? "bg-emerald-400" : status === "error" ? "bg-red-400" : "bg-creme/40"
            }`}
          />
          {status === "ok" ? "Online" : status === "error" ? "Erro" : "..."}
        </span>
      </div>
      <p className="mt-2 break-all rounded-md bg-obsidian/60 px-2.5 py-2 font-mono text-[0.65rem] text-dourado/80">
        {url}
      </p>
      <button
        type="button"
        data-testid={`banner-copy-${banner.file}`}
        onClick={copy}
        className="mt-3 w-full rounded-full border border-dourado/50 py-2 text-xs font-bold uppercase tracking-[0.15em] text-dourado transition-colors hover:bg-dourado hover:text-vinho"
      >
        Copiar URL
      </button>
    </div>
  );
}

export function BannersAdmin() {
  return (
    <section className="mt-16" data-testid="banners-admin-section">
      <h2 className="font-cinzel text-lg tracking-[0.25em] text-dourado">
        BANNERS MONETIZZE
      </h2>
      <p className="mt-2 text-sm text-creme/60">
        Seis banners hospedados com URL pública e permanente. Use cada URL no
        campo de mídia da Monetizze.
      </p>
      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2">
        {BANNERS.map((b) => (
          <BannerCard key={b.file} banner={b} />
        ))}
      </div>
    </section>
  );
}
